<template>
  <div>
    <b-row>
      <!-- MQSERIES -->
      <b-col sm="6" class="form-group">
        <form-write-group-label-input v-model="name" isMandatory :disabled="readonly"
          :inputLabel="$t('common.routing.config_name')" :placeholderValue="$t('common.routing.config_name')">
        </form-write-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group">
        <form-write-group-label-input v-model="host" isMandatory :disabled="readonly"
          :inputLabel="$t('common.routing.host')" :placeholderValue="$t('common.routing.host')">
        </form-write-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group">
        <form-write-group-label-input v-model="port" isMandatory :disabled="readonly"
          :inputLabel="$t('common.routing.port')" :placeholderValue="$t('common.routing.port')">
        </form-write-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group">
        <form-write-group-label-input v-model="connectionMode" isMandatory :disabled="readonly"
          :inputLabel="$t('common.routing.connection_mode')" :placeholderValue="$t('common.routing.connection_mode')">
        </form-write-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group">
        <form-write-group-label-input v-model="connectionType" isMandatory :disabled="readonly"
          :inputLabel="$t('common.routing.connection_type')" :placeholderValue="$t('common.routing.connection_type')">
        </form-write-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group">
        <form-write-group-label-input v-model="queueManager" isMandatory :disabled="readonly"
          :inputLabel="$t('common.routing.queue_manager')" :placeholderValue="$t('common.routing.queue_manager')">
        </form-write-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group">
        <form-write-group-label-input v-model="channelName" isMandatory :disabled="readonly"
          :inputLabel="$t('common.routing.channel_name')" :placeholderValue="$t('common.routing.channel_name')">
        </form-write-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group">
        <form-write-group-label-input v-model="queueName" isMandatory :disabled="readonly"
          :inputLabel="$t('common.routing.queue_name')" :placeholderValue="$t('common.routing.queue_name')">
        </form-write-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group">
        <label>
          {{ $t('common.routing.ssl_active') }}<span class="color-red"> * </span>
        </label>
        <select class="form-control" v-model="sslActive" :disabled="readonly">
          <option value="1"> {{ $t('common.routing.yes') }} </option>
          <option value="0"> {{ $t('common.routing.no') }} </option>
        </select>
      </b-col>
    </b-row>
    <level-control-form v-if="sslActive === '1'" :mode="mode" :readonly="readonly" v-model="controlConfig" :placementLevel="placementMQSeries"></level-control-form>
    <certificate-form-global v-if="sslActive === '1'" :mode="mode" :readonly="readonly" v-model="certificateConfig" :placementCertificate="placementMQSeries"></certificate-form-global>
    <private-keys-form-global v-if="sslActive === '1'" :mode="mode" :readonly="readonly" v-model="privateKeysConfig" :placementPrivateKey="placementMQSeries"></private-keys-form-global>
  </div>
</template>
<script>
import CertificateFormGlobal from '@/pages/routing/global/CertificateFormGlobal.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import LevelControlForm from '@/pages/routing/global/LevelControlForm.vue'
import PrivateKeysFormGlobal from '@/pages/routing/global/PrivateKeysFormGlobal.vue'


export default {
  name: 'MQSeriesConfigurationForm',
  components: {
    'certificate-form-global': CertificateFormGlobal,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'level-control-form' : LevelControlForm,
    'private-keys-form-global': PrivateKeysFormGlobal
  },
  props: {
    mode: {
      type: String,
      default: "create"
    },
    placementMQSeries: {
      type: Number,
      default: -1
    },
    readonly: {
      type: Boolean,
      default: false
    },
    value: {
      type: Object,
      default: () => {
        return {}
      }
    }

  },
  data () {
    return {
    }
  },
  computed:{
    inputValue: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    name:{
      get () {
        return this.inputValue.name
      },
      set (val) {
        this.inputValue = {
          name: val,
          host: this.inputValue.host,
          port: this.inputValue.port,
          sslActive: this.inputValue.sslActive,
          connectionMode: this.inputValue.connectionMode,
          connectionType: this.inputValue.connectionType,
          queueManager: this.inputValue.queueManager,
          channelName: this.inputValue.channelName,
          queueName: this.inputValue.queueName,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig
        }
      }
    },
    host:{
      get () {
        return this.inputValue.host
      },
      set (val) {
        this.inputValue = {
          name: this.inputValue.name,
          host: val,
          port: this.inputValue.port,
          sslActive: this.inputValue.sslActive,
          connectionMode: this.inputValue.connectionMode,
          connectionType: this.inputValue.connectionType,
          queueManager: this.inputValue.queueManager,
          channelName: this.inputValue.channelName,
          queueName: this.inputValue.queueName,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig
        }
      }
    },
    port:{
      get () {
        return this.inputValue.port
      },
      set (val) {
        this.inputValue = {
          name: this.inputValue.name,
          host: this.inputValue.host,
          port: val,
          sslActive: this.inputValue.sslActive,
          connectionMode: this.inputValue.connectionMode,
          connectionType: this.inputValue.connectionType,
          queueManager: this.inputValue.queueManager,
          channelName: this.inputValue.channelName,
          queueName: this.inputValue.queueName,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig
        }
      }
    },
    sslActive:{
      get () {
        return this.inputValue.sslActive === undefined ? '' : this.inputValue.sslActive
      },
      set (val) {
        this.inputValue = {
          name: this.inputValue.name,
          host: this.inputValue.host,
          port: this.inputValue.port,
          sslActive: val,
          connectionMode: this.inputValue.connectionMode,
          connectionType: this.inputValue.connectionType,
          queueManager: this.inputValue.queueManager,
          channelName: this.inputValue.channelName,
          queueName: this.inputValue.queueName,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig
        }
      }
    },
    connectionMode:{
      get () {
        return this.inputValue.connectionMode
      },
      set (val) {
        this.inputValue = {
          name: this.inputValue.name,
          host: this.inputValue.host,
          port: this.inputValue.port,
          sslActive: this.inputValue.sslActive,
          connectionMode: val,
          connectionType: this.inputValue.connectionType,
          queueManager: this.inputValue.queueManager,
          channelName: this.inputValue.channelName,
          queueName: this.inputValue.queueName,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig
        }
      }
    },
    connectionType:{
      get () {
        return this.inputValue.connectionType
      },
      set (val) {
        this.inputValue = {
          name: this.inputValue.name,
          host: this.inputValue.host,
          port: this.inputValue.port,
          sslActive: this.inputValue.sslActive,
          connectionMode: this.inputValue.connectionMode,
          connectionType: val,
          queueManager: this.inputValue.queueManager,
          channelName: this.inputValue.channelName,
          queueName: this.inputValue.queueName,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig
        }
      }
    },
    queueManager:{
      get () {
        return this.inputValue.queueManager
      },
      set (val) {
        this.inputValue = {
          name: this.inputValue.name,
          host: this.inputValue.host,
          port: this.inputValue.port,
          sslActive: this.inputValue.sslActive,
          connectionMode: this.inputValue.connectionMode,
          connectionType: this.inputValue.connectionType,
          queueManager: val,
          channelName: this.inputValue.channelName,
          queueName: this.inputValue.queueName,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig
        }
      }
    },
    channelName:{
      get () {
        return this.inputValue.channelName
      },
      set (val) {
        this.inputValue = {
          name: this.inputValue.name,
          host: this.inputValue.host,
          port: this.inputValue.port,
          sslActive: this.inputValue.sslActive,
          connectionMode: this.inputValue.connectionMode,
          connectionType: this.inputValue.connectionType,
          queueManager: this.inputValue.queueManager,
          channelName: val,
          queueName: this.inputValue.queueName,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig
        }
      }
    },
    queueName:{
      get () {
        return this.inputValue.queueName
      },
      set (val) {
        this.inputValue = {
          name: this.inputValue.name,
          host: this.inputValue.host,
          port: this.inputValue.port,
          sslActive: this.inputValue.sslActive,
          connectionMode: this.inputValue.connectionMode,
          connectionType: this.inputValue.connectionType,
          queueManager: this.inputValue.queueManager,
          channelName: this.inputValue.channelName,
          queueName: val,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig
        }
      }
    },
    controlConfig:{
      get () {
        return this.inputValue.controlConfig
      },
      set (val) {
        this.inputValue = {
          name: this.inputValue.name,
          host: this.inputValue.host,
          port: this.inputValue.port,
          sslActive: this.inputValue.sslActive,
          connectionMode: this.inputValue.connectionMode,
          connectionType: this.inputValue.connectionType,
          queueManager: this.inputValue.queueManager,
          channelName: this.inputValue.channelName,
          queueName: this.inputValue.queueName,
          controlConfig: val,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig
        }
      }
    },
    certificateConfig:{
      get () {
        return this.inputValue.certificateConfig
      },
      set (val) {
        this.inputValue = {
          name: this.inputValue.name,
          host: this.inputValue.host,
          port: this.inputValue.port,
          sslActive: this.inputValue.sslActive,
          connectionMode: this.inputValue.connectionMode,
          connectionType: this.inputValue.connectionType,
          queueManager: this.inputValue.queueManager,
          channelName: this.inputValue.channelName,
          queueName: this.inputValue.queueName,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: val,
          privateKeysConfig: this.inputValue.privateKeysConfig
        }
      }
    },
    privateKeysConfig:{
      get () {
        return this.inputValue.privateKeysConfig
      },
      set (val) {
        this.inputValue = {
          name: this.inputValue.name,
          host: this.inputValue.host,
          port: this.inputValue.port,
          sslActive: this.inputValue.sslActive,
          connectionMode: this.inputValue.connectionMode,
          connectionType: this.inputValue.connectionType,
          queueManager: this.inputValue.queueManager,
          channelName: this.inputValue.channelName,
          queueName: this.inputValue.queueName,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: val
        }
      }
    }
  },
  created () {
    if (this.mode === 'create') {
      this.inputValue.sslActive = "0"
    }
  },
  methods: {
  }
}
</script>
